/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars */

xplenty.service('edgeCreator', [
  function () {
    const _edgeId = 1000;

    return {
      create(sourceId, targetId) {
        return {
          id: new Date().getTime().toString(),
          source: sourceId,
          target: targetId,
          event: 'success',
        };
      },
    };
  },
]);
